import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import roles from '../utils/roles';
import {sortUserTasksByUserName, sortByName } from '../utils/sorting';

import ProjectDetails from './ProjectDetails';
import PMOProjectListWidget from './PMOProjectListWidget';

import attributeActions from '../actions/attributeActionCreators';
import customerActions from '../actions/customerActionCreators';
import projectActions from '../actions/projectActionCreators';
import taskActions from '../actions/taskActionCreators';
import userActions from '../actions/userActionCreators';

require.ensure([], () => {
    require('./PMO.less');
});

class PMO extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            activeProject: this.props.activeProject,
            fullProjectDetailsVisible: false,
            newProjectVisible: false,
            showModal: false,
            tasksVisible: this.props.activeProject ? true : false
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        if (!this.props.currentUser)
            this.props.dispatch(userActions.loadCurrentUser());

        this.props.dispatch(userActions.loadAllUsers());
        this.props.dispatch(userActions.loadPms());
        this.props.dispatch(userActions.loadRegularUsers());
        this.props.dispatch(userActions.loadSponsors());
        this.props.dispatch(attributeActions.loadAll());
        this.props.dispatch(attributeActions.loadDefaultAttributes());
        this.props.dispatch(customerActions.loadAll());

        setTimeout(() => {
            let queryParams = this.props.routeParams;
            if (!roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PM', 'PMO']))
                browserHistory.push('/');

            if (queryParams.project) {
                let project;
                for (let i = 0; i < this.props.allProjects.length; i++) {
                    let projectID = this.props.allProjects[i].id;
                    if (projectID === queryParams.project) {
                        project = this.props.allProjects[i];
                        break;
                    }
                }

                if (project) this.handleProjectItemClick(project);
            }
        }, 2000);
    }

    // EVENT HANDLERS

    handleAddProject = (project) => { this.props.dispatch(projectActions.create(project)); }

    handleAddTask = (projectID) => { this.props.dispatch(taskActions.loadByProject(projectID)); }

    handleArchiveProject = (project) => {
        this.props.dispatch(projectActions.archive(project));

        this.setState({
            activeProject: null,
            fullProjectDetailsVisible: false,
            newProjectVisible: false,
            tasksVisible: false
        })
    }

    handleUnarchiveProject = (project) => {
        this.props.dispatch(projectActions.unarchive(project));

        this.setState({
            activeProject: null,
            fullProjectDetailsVisible: false,
            newProjectVisible: false,
            tasksVisible: false
        })
    }

    handleDeleteProject = (projectID) => {
        this.props.dispatch(projectActions.delete(projectID));

        this.setState({
            activeProject: null,
            fullProjectDetailsVisible: false,
            newProjectVisible: false,
            tasksVisible: false
        });
    }

    handleEditProject = (project) => {
        this.props.dispatch(projectActions.edit(project));
        this.setState({ activeProject: project });
    }

    handleNewProjectClick = () => { this.setState({ newProjectVisible: !this.state.newProjectVisible });
    }

    handleProjectItemClick = (project) => {
        this.props.dispatch(taskActions.loadByProject(project.id));
        this.props.dispatch(projectActions.getUnbilledHours(project.id))

        this.setState({
            activeProject: project,
            tasksVisible: true
        });
    }

    handleRemoveProject = (project) => { this.setState({ showModal: true, }); }

    // OTHER METHODS

    hideModalDialog = () => { this.setState({ showModal: false }); }

    syncUsersWithLdap = () => { this.props.dispatch(userActions.syncUsersWithLdap()); }

    // RENDER METHOD

    render = () => {
        return (
            <div>
                {
                    //this.state.showModal ? modal : null
                }
                <div className="row">
                    <PMOProjectListWidget
                        activeProject={this.state.activeProject}
                        archivedProjects={this.props.archivedProjects}
                        handleFunction={this.handleProjectItemClick}
                        handleNewProject={this.handleAddProject}
                        handleRemoveProject={this.handleRemoveProject}
                        newProjectFunction={this.handleNewProjectClick}
                        projectNames={this.props.projectNames}
                        unarchivedProjects={this.props.unarchivedProjects}
                        />
                    {
                        this.state.newProjectVisible ?
                        null
                        :
                            this.state.fullProjectDetailsVisible ?
                                null
                                :
                                this.state.tasksVisible ?
                                    <ProjectDetails
                                        handleArchiveProject={this.handleArchiveProject}
                                        handleUnarchiveProject={this.handleUnarchiveProject}
                                        handleDeleteProject={this.handleDeleteProject}
                                        handleEditProject={this.handleEditProject}
                                        id={this.state.activeProject.id}
                                        key={this.state.activeProject.id}
                                        project={this.state.activeProject}
                                        projectNames={this.props.projectNames}
                                        tasks={this.props.tasksToShow}
                                        taskAddedHandler={this.handleAddTask}
                                        taskNames={this.props.taskNames}
                                        users={this.state.usersAssigned}    // TODO always undefined
                                        userTasks={this.props.userTasksToShow}
                                        />
                                    :
                                    null
                    }
                </div>
            </div>
        );
    }
}

PMO.propTypes = {
    activeProject: PropTypes.object,
    allProjects: PropTypes.array,
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    projectAttributes: PropTypes.array,
    projectNames: PropTypes.array,
    routeParams: PropTypes.object,
    taskNames: PropTypes.array,
    tasksToShow: PropTypes.array,
    userTasksToShow: PropTypes.array,
};

const mapStateToProps = (state) => {
    let allProjects = state.projects.unarchivedProjects.concat(state.projects.archivedProjects);
    let taskNames = [];
    let projectNames = [];
    allProjects.map((project, key) => {
        if (project.name) {
            projectNames.push(project.name.toLowerCase());
        }
    });

    tasksToShow: state.tasks.tasks.map((task, key) => {
            taskNames.push(task.name.toLowerCase());
    });

    //sort using copied array to avoid state mutation before mapping to props
    let userTasks = state.userTasks.userTasks.slice(0);
    userTasks.sort(sortUserTasksByUserName);

    let tasks = state.tasks.tasks.slice(0);
    tasks.sort(sortByName);

    let archivedProjects = state.projects.archivedProjects.slice(0);
    archivedProjects.sort(sortByName);

    let unarchivedProjects = state.projects.unarchivedProjects.slice(0);
    unarchivedProjects.sort(sortByName);

    return {
        activeProject: state.projects.activeProject,
        allProjects: state.projects.allProjects,
        archivedProjects: archivedProjects,
        currentUser: state.users.currentUser,
        createdProject: state.projects.createdProject,
        projectAttributes: state.attributes.attributes,
        projectNames: projectNames,
        taskNames: taskNames,
        tasksToShow: tasks,
        unarchivedProjects: unarchivedProjects,
        userTasksToShow: userTasks
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PMO);



/** WEBPACK FOOTER **
 ** ./src/app/components/PMO.js
 **/